import { config } from '@shakkerai/config';

export const toUserPage = (uuid, tab, type) => {
  let hostname = '';

  if (config.env === 'aliyun') {
    if (config.name === 'pre') {
      hostname = 'https://www-pre.liblib.art';
    } else if (config.name === 'test') {
      hostname = 'https://www-test.liblib.art';
    } else {
      hostname = 'https://www.liblib.art';
    }
  }

  if (!type && tab) {
    return `${hostname}/userpage/${uuid}/${tab}`;
  }
  if (type && tab) {
    return `${hostname}/userpage/${uuid}/${tab}/${type}`;
  }
  return `${hostname}/userpage/${uuid}`;
};

export const CommonAtomInfoMap = {
  colorAdjustment: {
    type: 'sync',
    name: 'colorAdjustment',
    title: 'Color adjustment',
    metaInfo: {
      inputList: [],
    },
  },
};

export const MAX_FILE_SIZE = 1024 * 1024 * 20;
